import { render, staticRenderFns } from "./PurchaseOrderOrderSummary.vue?vue&type=template&id=ff8b91aa&scoped=true"
import script from "./PurchaseOrderOrderSummary.ts?vue&type=script&lang=ts&external"
export * from "./PurchaseOrderOrderSummary.ts?vue&type=script&lang=ts&external"
import style0 from "./PurchaseOrderOrderSummary.scss?vue&type=style&index=0&id=ff8b91aa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8b91aa",
  null
  
)

export default component.exports